// Resolves the customer-area display mode. Embedding pages (Neos/Shopify) used
// to inject `window.CUSTOMERAREA_DISPLAY_MODE` before bootstrap; iframe embeds
// can't reach into a cross-origin frame, so we also accept `?displayMode=` on
// the URL. window wins if both are set so existing embeds keep working.

export function getDisplayMode () {
  if (typeof window === 'undefined') return 'login'
  if (window.CUSTOMERAREA_DISPLAY_MODE) return window.CUSTOMERAREA_DISPLAY_MODE
  try {
    const fromQuery = new URLSearchParams(window.location.search).get('displayMode')
    if (fromQuery) return fromQuery
  } catch (e) { /* no-op */ }
  return 'login'
}
